const SendSMSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        d="M17.1778 0.908983L17.1778 0.908985L1.11388 6.2637C1.11388 6.2637 1.11388 6.2637 1.11388 6.2637C0.0718704 6.611 0.104163 8.09592 1.16022 8.3976L8.89289 10.607L11.1022 18.3397L11.2465 18.2985L11.1022 18.3397C11.404 19.3958 12.8888 19.4282 13.2361 18.386L18.5908 2.3221L18.4485 2.27467L18.5908 2.32209C18.8819 1.44881 18.0512 0.617911 17.1778 0.908983ZM10.1169 10.2789L16.8459 3.55005L12.1874 17.5254L10.1169 10.2789ZM1.9746 7.31249L15.9499 2.65403L9.22102 9.38288L1.9746 7.31249Z"
        fill="#183883"
        stroke="#183883"
        strokeWidth="0.3"
      />
    </svg>
  );
};
export default SendSMSIcon;
